import './travel-banner.scss';

export default () => {

};
